export type ComponentsFormTranslation = {
  select: {
    createItem: string;
    loading: string;
    noOptionsMessage: string;
    selected: string;
    typeToSearch: string;
  };
};

export const componentsFormTranslation: ComponentsFormTranslation = {
  select: {
    createItem: 'Create "{{item}}"',
    loading: 'Loading…',
    noOptionsMessage: 'No options available',
    selected: 'Selected: {{value}}',
    typeToSearch: 'Type to search',
  },
};
